<template>
  <div class="title-wrap">
    <div class="divider" :class="[sex == 0 ? 'bg-girl' : 'bg-boy']"></div>
    <span>{{ title }}</span>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      default: "xxx",
    },
  },
  computed: {
    sex() {
      return (this.$store.state.ReportData.studentInfo || {}).sex || 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.title-wrap {
  padding: 5px;
  display: flex;
  align-items: center;
  .divider {
    width: 4px;
    height: 16px;
    margin: 0 8px;
  }
}
</style>